// extracted by mini-css-extract-plugin
export default {"page":"JF4F_","answers":"P8xSX","answer":"PKNw_","readOnlyAnswer":"_zAgh","answerImg":"s2aHc","actions":"KGiEg"};